import CryptoJS from "crypto-js";

const ENCRYPTION_KEY = CryptoJS.enc.Utf8.parse("example key 1234");

// Encrypts a plain string (email/password) with AES-CBC before it's sent to
// the API. The backend expects a fresh random IV per call, prepended to the
// ciphertext and base64-encoded as a single blob — it splits the first 16
// bytes back off as the IV before decrypting the rest (see
// usermvc/service/usersservice/crypto.go's aesDecrypt).
export function encryptInfo(info: string = ""): string {
  const iv = CryptoJS.lib.WordArray.random(16);
  const encrypted = CryptoJS.AES.encrypt(info, ENCRYPTION_KEY, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return CryptoJS.enc.Base64.stringify(iv.concat(encrypted.ciphertext));
}
